module.exports = __webpack_public_path__ + "img/yy (4).b7bc47b3.png";